module.exports = __webpack_public_path__ + "img/header-sm.7b6eeebc.png";